// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2jQ0Y","notes":"Notes_notes__1WCpz","note":"Notes_note__1GM1A","markdown":"Notes_markdown__hcqgH"};